import {
  ModuleWithProviders,
  NgModule,
  InjectionToken,
  Inject
} from '@angular/core';
import { TableState } from './table-definition';
import { Store } from '@ngrx/store';
import { RegisterTables } from './table.actions';

export const TABLE_DEFINITIONS = new InjectionToken(
  '@digitaix/core/tables/TABLE_DEFINITIONS'
);



@NgModule()
export class DxFormsDefinitionLoaderModule {
  public static forSandbox(definitions: {
    [ tableId: string ]: Partial<TableState<any>>;
  }): ModuleWithProviders {
    return {
      ngModule:  DxFormsDefinitionLoaderModule,
      providers: [
        {
          provide:  TABLE_DEFINITIONS,
          useValue: definitions
        }
      ]
    };
  }

  constructor(store$: Store<any>, @Inject(TABLE_DEFINITIONS) definitions: any) {
    store$.dispatch(new RegisterTables(definitions));
  }
}
